<template>
    <cod-dialog
        ref="commentsDialog"
        :show.sync="showDialog"
        back-icon="fal fa-arrow-left"
    >
        <!-- Header -->
        <div slot="header" class="header">
            {{ $t('general.comment') }}
        </div>

        <!-- Content -->
        <div slot="content" class="content">
            <div class="mx-4 my-2 d-flex align-center">
                <v-text-field
                    v-model="filterQuery"
                    class="mt-2 mr-4"
                    :placeholder="$t('general.comment')"
                    clearable
                    clear-icon="fal fa-times"
                    @keyup.enter.native="selectSingle(filterQuery)"
                />

                <v-btn
                    color="primary"
                    outlined
                    :disabled="!filterQuery"
                    @click="selectSingle(filterQuery)"
                >
                    <v-icon left>fal fa-plus</v-icon>
                    {{ $t('general.add') }}
                </v-btn>
            </div>

            <v-list v-if="filtered.length" class="pa-0">
                <v-divider />

                <template v-for="(comment, index) in filtered">

                    <v-list-item
                        :id="`comment-${index}`"
                        :key="index"
                        :class="{item: true, selected: selected.includes(comment)}"
                        @click="selectSingle(comment)"
                    >
                        <v-list-item-content>
                            <v-list-item-title>{{ comment }}</v-list-item-title>
                        </v-list-item-content>

                        <v-scale-transition hide-on-leave>
                            <v-list-item-icon v-show="selected.includes(comment)">
                                <v-icon :size="24" color="success">far fa-check</v-icon>
                            </v-list-item-icon>
                        </v-scale-transition>

                    </v-list-item>

                    <v-divider :key="`${index}-divider`" />

                </template>
            </v-list>
        </div>

        <!-- Footer -->
        <v-row slot="footer" justify="space-between">

            <v-btn
                class="flex-1 mr-1"
                color="primary"
                outlined
                @click="showDialog = false"
            >
                {{ $t('general.close') }}
            </v-btn>

            <v-btn
                class="flex-1 ml-1"
                color="primary"
                depressed
                @click="select"
            >
                {{ $t('general.confirm') }}
            </v-btn>

        </v-row>

    </cod-dialog>

</template>

<script>
import CodDialog from '@/components/CodDialog';
import OrderItemComment from '@/models/OrderItemComment';

export default {
    components: {
        CodDialog
    },

    props: {
        show: {
            type: Boolean,
            default: false
        },
        orderItem: {
            type: Object,
            default: () => {}
        }
    },

    data: () => ({
        showDialog: false,
        filterQuery: null,
        selected: [],
        filtered: [],
        comments: []
    }),

    watch: {
        show(val) {
            this.showDialog = val;

            if (val) {
                this.selected = [];
                this.orderItem.comments.forEach(comment => { this.selected.push(comment) });
                this.comments = [
                    ...this.selected,
                    ...OrderItemComment.all().map(orderItemComment => orderItemComment.comment)
                ].filter((comment, index, array) => index === array.indexOf(comment))

                this.filterQuery = null;
                this.filter();
                this.$nextTick(() => {
                    this.$refs.commentsDialog.$refs.content.scrollTop = 0;
                });
            }
        },

        showDialog(val) {
            this.$emit('update:show', val);
        },

        comments() {
            this.filter();
        },

        filterQuery() {
            this.filter();
        }
    },

    methods: {
        selectSingle(selectedComment) {
            if (!this.selected.includes(selectedComment)) {
                this.selected.push(selectedComment)
            } else {
                this.selected = this.selected.filter(comment => comment !== selectedComment);
            }

            if(!this.comments.includes(selectedComment)) {
                this.comments.push(selectedComment);
                this.filterQuery = null;
            }
        },

        select() {
            this.showDialog = false;
            this.$emit('select', this.orderItem, this.selected);
        },

        filter() {
            let filtered = [];

            this.comments.forEach(comment => {
                if (this.selected.includes(comment)) {
                    filtered.unshift(comment);
                } else {
                    filtered.push(comment);
                }
            });

            if (!this.filterQuery) {
                this.filtered = filtered;
                return;
            }

            this.filtered = filtered.filter(comment => {
                return (
                    this.selected.includes(comment) ||
                    comment.toLowerCase().includes(this.filterQuery.toLowerCase())
                );
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.header {
    width: 100%;
}

.content {
    height: 440px;

    .item {
        max-height: 48px;
    }

    .selected {
        background: #efefef;

        .v-list-item__icon {
            margin: 0;
            height: 48px;
        }
    }
}
</style>
